module.exports = __webpack_public_path__ + "static/media/限时优惠@2x.776814c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_135/imgs/限时优惠@2x.png
// module id = 395
// module chunks = 0